<template>
<div class="page-guide _privacy">

    <h1 class="heading_section-title">
        <p class="main">COMPANY INFO</p>
        <span>運営会社情報</span>
    </h1>


    <section class="terms-overflow-div">
        <div class="inner">

            <div class="detail-item-wrap">

                <div class="detail-item edit-checkbox">
                    <ul class="list_common">
                        <li>
                            <div class="title guideLinr-element-highlight"><span>会社名</span></div>
                            <div class="detail"><p><span>株式会社Freeliving.</span></p></div>
                        </li>
                        <li>
                            <div class="title guideLinr-element-highlight"><span>住所</span></div>
                            <div class="detail"><p><span>大分県大分市府内町3丁目2-25 府内イデアビル2F</span></p></div>
                        </li>
                        <li>
                            <div class="title guideLinr-element-highlight"><span>代表取締役</span></div>
                            <div class="detail"><p><span>田口 和恵</span></p></div>
                        </li>
                        <li>
                            <div class="title guideLinr-element-highlight"><span>資本金</span></div>
                            <div class="detail"><p><span>1,000万</span></p></div>
                        </li>
                        <li>
                            <div class="title guideLinr-element-highlight"><span>メール</span></div>
                            <div class="detail"><p><span>お問い合わせフォーム（<a href="mailto:support@auma.jp?subject=【AUMAサポート】問い合わせ&amp;body=ご記入ください"><span>support@auma.jp</span></a>）</span></p></div>
                        </li>
                        <li>
                            <div class="title guideLinr-element-highlight"><span>事業内容</span></div>
                            <div class="detail"><p><span>Webサービス企画・開発・プラットフォームの運営・BtoB（企業間電子商取引）</span></p></div>
                        </li>
                        <li>
                            <div class="title guideLinr-element-highlight"><span>事業計画</span></div>
                            <div class="detail"><p><span>アナリティクス機能<br>AUMA 多言語対応<br>展示会カレンダー機能<br>AUMA内での求人案内<br>ブランドの育成ツール（人材育成機能）パーソナル登録</span></p></div>
                        </li>
                    </ul>
                </div>



            </div><!--/.detail-item-wrap-->

        </div><!--/.section-inner-->

    </section>



</div>
</template>

<style>
.terms-overflow-div {
    width: 100%;
    padding: 0rem 2rem;
    padding-bottom: 15rem;
}
.terms-overflow-div .inner {
    width: 100%;
    max-width: 780px;
    margin: auto;
}
.terms-overflow-div .inner h3.heading {
    font-size:1.25rem;
    font-weight: 700;
	padding-bottom: 1rem;
    text-align: center;
}
.terms-overflow-div div.terms-item-wrap {
    padding-bottom: 1rem;
	margin-bottom: 1rem;
}
</style>

<script>
    import EndUserLayout from '@/Layouts/EndUserLayout'

    export default {
        layout: EndUserLayout,
        components: {
        },
        mounted() {

        }
    }
</script>